export default __webpack_public_path__ + "static/media/FacilityProfileFrameIcon.0b17c074.svg";